import { Component } from '@angular/core';
import { DatePicker } from '@ionic-native/date-picker';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { Utility } from '@providers/resources/utility';

import { SelectPage, DetailImagePage } from '../';
import { Schedule, Master, Dokumen } from '@providers/index';

@Component({
  selector: 'page-form-schedule',
  templateUrl: 'page.html'
})
export class FormSchedulePage {

  form = {
    id            : '',
    activity_type : '',
    activity      : '',
    date_start    : '',
    date_end      : '',
    description   : '',
    pic_name      : '',
    pic_id        : '',
    project_id    : '',
    state_id      :  1,
    stage_id      : '',
  };

  images        : any = [];
  images_new    : any = [];
  listStage     : any = [];
  project       : any = {};
  loading       : any;
  img_url             = '';
  activity_type :any  = []; 

  buildApk = this.utility.buildApk
  
  constructor(
    public navCtrl     : NavController,
    public navParams   : NavParams,
    private toastCtrl  : ToastController,
    public loadingCtrl : LoadingController,
    public modalCtrl   : ModalController,
    public datePicker  : DatePicker,
    public camera      : Camera,
    public scheduleApi : Schedule,
    public masterApi   : Master,
    public dokumenApi  : Dokumen,
    public utility     : Utility
  ) {

    this.getStage();
    this.project = this.navParams.get('project');
    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
      this.getImagesByID();
    }

    this.img_url = this.dokumenApi.file_url;
    this.getActivityType();
    
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  stageChange(p,c){
    this.form.activity = c.text;
  }

  getStage(){
    this.showLoading();
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
      this.loading.dismiss();
    });
  }

  pilihPIC() {
    let picModal = this.modalCtrl.create(SelectPage, { select_mod: 2 });
    picModal.onDidDismiss(data => {
      if(data.item){
        this.form.pic_name = data.item.name;
        this.form.pic_id   = data.item.user_id;
      } 
    console.log(data.item);
    });
    picModal.present();
  }

  save(){
    if(this.form.activity_type==''){
      this.presentToast('Activity type cannot empty !');
      return;
    }
    this.showLoading();

    this.form.project_id = this.project.id;
    let params:any = this.form;

    params.dokument_id = '';
    let dok_arr = [];
    this.images_new.forEach(el => {
      if(el.project_id==undefined){
        dok_arr.push(el.dokument_id);
      }
    });
    params.dokument_id = dok_arr.join(',');
    params.dokument_type = 'start';

    this.scheduleApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality        : 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth    : 1024,
      sourceType     : camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  getImagesByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params : any =  {
      schedule_id : this.form.id
    };
    let get : any;
    get = this.scheduleApi.getScheduleImage(params);
      get.subscribe((resp:any) => {
        if(resp.data.length>0){
          this.images = resp.data;
        }
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      resp.data.dokument_id=resp.data.id;
      resp.data.id='';
      this.images.push(resp.data);
      this.images_new.push(resp.data);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+rec.generated_name,
      detail    : rec,
      edit      : true
    });
    profileModal.present();
    console.log("Image params => ", rec);
  }

  getActivityType(){
    this.scheduleApi.getActivityType().subscribe((resp:any) => {
      this.activity_type = resp.data;
      console.log(resp);
    });
  }


  selectDateStart(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      // minDate: new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date_start = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }
  selectDateEnd(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      // minDate: new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date_end = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/form_schedule/page.ts